import * as yup from 'yup'

/**
 * The backend parses this file with `@GigsafeParsedCsv(AdminPartnerHistoricalInvoiceDto)` and
 * validates every row, so the only client-side rule worth having is that a file was chosen at
 * all. Row-level validation is deliberately NOT duplicated here — the server is the authority on
 * the column contract, and a second copy would drift from it.
 */
export const historicalInvoicesFormValidator = yup.object({
  file: yup.mixed<File>().nullable().required('Choose a CSV to upload'),
})
